import { motion } from "framer-motion";
import { Check } from "lucide-react";

export const SequenceStrip = ({ category, count, next }) => (
  <div data-testid="sequence-strip" className="mt-3 flex flex-wrap gap-1.5">
    {Array.from({ length: count }, (_, k) => k + 1).map((v) => {
      const done = v < next;
      const current = v === next;
      return (
        <motion.div key={v} data-testid={`sequence-item-${v}`} animate={current ? { scale: [1, 1.12, 1] } : { scale: 1 }} transition={current ? { repeat: Infinity, duration: 1.2 } : {}}
          className={`relative grid h-8 w-8 place-items-center rounded-lg text-base text-white sm:h-9 sm:w-9 sm:text-lg ${current ? "bg-gradient-to-br from-amber-400 to-fuchsia-500 ring-2 ring-white/70" : done ? "bg-emerald-500/30 opacity-60" : "bg-white/10"}`}>
          {category.render(v)}
          {done && <Check className="absolute -right-1 -top-1 h-3.5 w-3.5 rounded-full bg-emerald-500 p-0.5 text-white" />}
        </motion.div>
      );
    })}
  </div>
);
